const typography = {
    h1: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 300,
        fontSize: '96px',
        lineHeight: '112px',
        letterSpacing: '-1.5px',
    },
    h2: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 300,
        fontSize: '60px',
        lineHeight: '70px',
    },
    h3: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '48px',
        lineHeight: '56px',
    },
    h4: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '34px',
        lineHeight: '40px',
        letterSpacing: '0.25px',
    },
    h5: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '24px',
        lineHeight: '28px',
    },
    h6: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 500,
        fontSize: '20px',
        lineHeight: '28px',
        letterSpacing: '0.15px',
    },
    body1: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.44px',
    },
    body2: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.25px',
    },
    subtitle2: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '24px',
        letterSpacing: '0.1px',
    },
    subtitle1: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.15px',
    },
    button: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '16px',
        letterSpacing: '0.75px',
        textTransform: 'uppercase',
    },
    caption: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
    },
    overline: {
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 'normal',
        fontSize: '10px',
        lineHeight: '16px',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
    },
};
export default typography;
